import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const ProjectManagement: React.FC = () => {
  return (
    <section className="project-section-modern">
      <Container>
        <Row>
          <Col lg={8} className="mx-auto text-center">
            <h2 className="section-title mb-3">
              Built to scale your revenue
            </h2>
            <p className="section-subtitle mb-5">
              From solo operators to 20+ person teams, we build custom integrations and sales pipelines that grow with your business
            </p>
            <div className="stats-row-modern">
              <div className="stat-item-modern">
                <div className="stat-value-modern">2-20</div>
                <div className="stat-label-modern">Team members</div>
              </div>
              <div className="stat-item-modern">
                <div className="stat-value-modern">End-to-End</div>
                <div className="stat-label-modern">Lead pipelines</div>
              </div>
              <div className="stat-item-modern">
                <div className="stat-value-modern">Automated</div>
                <div className="stat-label-modern">Sales follow-up</div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ProjectManagement;
